import { blue20, blue20opacity50 } from '../../../colors/blue';
import { rem } from '../../../utils/rem';
export var MuiButtonGroup = {
    styleOverrides: {
        outlined: {
            '& [class*=MuiButton-containedPrimary]': {
                border: "".concat(rem(1), " solid ").concat(blue20opacity50),
                color: blue20,
                '&:hover': {
                    background: 'rgba(100, 174, 248, 0.08)',
                    border: "".concat(rem(1), " solid ").concat(blue20),
                    color: blue20,
                },
            },
        },
    },
};
